import { CircleDollarSign } from "lucide-react";

type CoinMoneyIconProps = {
  size?: "sm" | "md";
  className?: string;
};

const shellClass: Record<NonNullable<CoinMoneyIconProps["size"]>, string> = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
};

const iconFill = "h-[122%] w-[122%]";

export function CoinMoneyIcon({ size = "md", className }: CoinMoneyIconProps) {
  return (
    <span
      className={`relative inline-flex shrink-0 overflow-hidden rounded-full bg-linear-to-b from-amber-200 via-amber-300 to-amber-500 text-amber-950 shadow-[inset_0_1px_0_rgba(255,255,255,0.4)] ring-1 ring-amber-800/25 ${shellClass[size]} ${className ?? ""}`}
      aria-hidden
    >
      <CircleDollarSign
        className={`absolute left-1/2 top-1/2 max-h-none max-w-none -translate-x-1/2 -translate-y-1/2 ${iconFill}`}
        strokeWidth={1.25}
      />
    </span>
  );
}
